import React from "react";
import { Box, useTheme, Typography, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import KaCite from "./KaCite";

const useStyles = makeStyles(theme => ({
  root: {
    color: "white"
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block"
  },
  imageMobile: {
    width: "100%",
    height: "auto",
    display: "block"
  }
}));

const KaDialogContentMainImageInfo = ({
  image,
  mainContent,
  infoContent,
  infoFootnote
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));

  const space = mobile ? 2 : 3;

  const img = (
    <Box mb={space}>
      <img src={image} alt="" className={classes.imageMobile} />
    </Box>
  );

  return (
    <Box
      p={space}
      display="flex"
      flexDirection={mobile ? "column" : "row"}
      className={classes.root}
      style={{ gap: mobile ? 0 : `${space * 8}px` }}
    >
      {mobile && img}
      <Box
        flex="1 1 0"
        minWidth={0}
        maxWidth={mobile ? "100%" : "50%"}
        bgcolor={theme.palette.primary.main}
        mb={mobile ? space : 0}
        px={mobile ? space : 4}
        py={mobile ? space : 0}
        display="flex"
        alignItems="center"
      >
        {mainContent}
      </Box>
      <Box flex="1 1 0" minWidth={0} maxWidth={mobile ? "100%" : "50%"} display="flex" flexDirection="column" style={{ gap: `${space * 8}px` }}>
        {!mobile && (
          <Box flex="1 1 0" minHeight={300} overflow="hidden">
            <img src={image} alt="" className={classes.image} />
          </Box>
        )}
        <Box flex="1 1 0" minHeight={mobile ? 180 : 300}>
          <KaCite
            content={infoContent}
            footnote={infoFootnote}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default KaDialogContentMainImageInfo;
